import { Component, OnInit } from '@angular/core';

import { ClientService } from '../../services/client.service';

@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {
  client: any = {};
  footerContent: string = "";
  constructor(private clientService: ClientService) {
    this.client = this.clientService.getClient();
    if(this.client != null) {
      this.footerContent = this.footerContent = this.client.clientSetting.siteSetting.footerContent;
    }
  }

  ngOnInit() {}

}
